<h2 mat-dialog-title>Compartilhar</h2>

<mat-dialog-content class="content">
    <div class="share-container">
        <!-- Lado Esquerdo: Link + Botões -->
        <div class="share-info">
            <p class="description">Copie o link abaixo e convide seus candidatos para participar do processo seletivo</p>
            <mat-form-field appearance="outline" class="full-width">
                <input matInput [value]="shareLink" readonly>
                <button mat-icon-button matSuffix (click)="copyLink(processList)">
                    <mat-icon>content_copy</mat-icon>
                </button>
            </mat-form-field>

            <p class="description">Baixe o conteúdo nos formatos desejados:</p>
            <div class="buttons">
                <button mat-raised-button color="primary" (click)="downloadPDF()">
                    <mat-icon>picture_as_pdf</mat-icon> PDF
                </button>
                <button mat-raised-button color="accent" (click)="downloadPNG()">
                    <mat-icon>image</mat-icon> PNG
                </button>
            </div>
        </div>

        <!-- Lado Direito: Miniatura Grande -->
        <div class="thumbnail">
            <p class="description">Visualização do conteúdo compartilhado:</p>
            
             <!-- Ícone de loading enquanto a imagem carrega -->
            <mat-progress-spinner
                *ngIf="imageLoading"
                mode="indeterminate"
                color="primary"
                diameter="50">
            </mat-progress-spinner>

            <!-- Imagem carregada -->
            <img 
                [src]="previewImage" 
                alt="Miniatura" 
                *ngIf="!imageLoading"
            >
        </div>
    </div>
</mat-dialog-content>

<mat-progress-bar *ngIf="submiting"></mat-progress-bar>

<mat-dialog-actions *ngIf="!submiting">
    <button color="accent" mat-button mat-dialog-close>Fechar</button>
</mat-dialog-actions>
